jQuery($ => {
	// region VARIABLES

	// TODO: Add setting to enable 'Toggle on Hover' (instead of clicking the sidebar part...), probably in Customizer
	// Sidebar
	const sidebar = {
		this: $('#sidebar')
	};

	// endregion VARIABLES

	// region INITIALIZATION

	Init();

	function Init()
	{
		// Setup sidebar
		SetupSidebar();
	}

	function SetupSidebar()
	{
		// Setup sidebar listeners
		sidebar.this.on({
			click: function(event){
				if($(event.target).is(this) || $(event.target).is($(this).children('.icon')))
					ToggleSidebar();
			}
		});
	}

	// endregion INITIALIZATION

	// region SIDEBAR

	function ToggleSidebar(state = null)
	{
		// Toggle sidebar state
		if(state === true)
			sidebar.this.removeClass('closed');
		else if(state === false)
			sidebar.this.addClass('closed');
		else
			sidebar.this.toggleClass('closed');
	}

	// endregion SIDEBAR
});